export const frequencyThresholdRowColumnFlex = {
  label: 1,
  value: 1,
  context: 1,
  unit: 1,
} as const;

export const avgDurationThresholdRowColumnFlex = {
  label: 1,
  value: 1,
  context: 1,
  unit: 1,
} as const;

export const frequencyThresholdRowTemplateColumns = `${frequencyThresholdRowColumnFlex.label}fr ${frequencyThresholdRowColumnFlex.value}fr ${frequencyThresholdRowColumnFlex.context}fr ${frequencyThresholdRowColumnFlex.unit}fr`;
export const avgDurationThresholdRowTemplateColumns = `${avgDurationThresholdRowColumnFlex.label}fr ${avgDurationThresholdRowColumnFlex.value}fr ${avgDurationThresholdRowColumnFlex.unit}fr ${avgDurationThresholdRowColumnFlex.context}fr`;
